import React from 'react'
import { Text } from '@/components/atoms/Text'
import { CategoryChip } from '@/components/atoms/CategoryChip'
import './SectionHeader.css'

export interface SectionHeaderProps {
  title: React.ReactNode
  description?: string
  chips?: string[]
  className?: string
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  description,
  chips,
  className = '',
}) => {
  return (
    <div className={`section-header ${className}`}>
      <Text
        size="extra-large"
        color="primary"
        weight="extra-bold"
        className="section-header-title"
      >
        {title}
      </Text>

      {description && (
        <Text size="large" color="gray" weight="normal" className="section-header-description">
          {description}
        </Text>
      )}

      {chips && chips.length > 0 && (
        <div className="section-header-chips">
          {chips.map((chip, index) => (
            <CategoryChip key={index} label={chip} />
          ))}
        </div>
      )}
    </div>
  )
}
